export const STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}

export const SEARCHABLE = {
  YES : true,
  NO  : false
}
